
const mounthYear = function (value) {
    var dates = value.split("-");
    return dates[0] + "/" + dates[1]
    
}

export {
    mounthYear
}
